class Configuration {
  static adminAPIUrl = '/api/admin';
}
export default Configuration;
